module.exports = __webpack_public_path__ + "img/blessing_prize_5.c4515628.png";